import React, { useCallback, useEffect } from 'react'
import { EmploymentSection } from '../../../EmploymentSection'
import { useAnalysisMode } from '../../contexts/AnalysisModeContext'
import { useAnalysisServices } from '../../contexts/AnalysisServicesContext'
import { useAnalysisMapSectionData } from '../../contexts/MapSectionDataContext'

export const EmploymentTab: React.FC = () => {
  const { entity, userId, readOnly } = useAnalysisMode()
  const { getSectionData, updateSectionData, onDataFetched } =
    useAnalysisServices()
  const { setActiveSection, updateSectionData: updateMapData } =
    useAnalysisMapSectionData()

  useEffect(() => {
    setActiveSection('employment')
  }, [setActiveSection])

  const handleDataFetched = useCallback(
    (data: any) => {
      onDataFetched('employment', data)

      if (data?._isochrone) {
        updateMapData({
          employment: {
            isochrone: data._isochrone,
            isochroneMode: data._isochroneMode,
          },
        })
      } else {
        updateMapData({
          employment: {
            isochrone: null,
            isochroneMode: null,
          },
        })
      }
    },
    [onDataFetched, updateMapData]
  )

  const handleUpdateEmploymentData = useCallback(
    async (ent: any, uid: string, params: any) => {
      const result = await updateSectionData('employment', ent, uid, params)
      handleDataFetched(result)
      return result
    },
    [updateSectionData, handleDataFetched]
  )

  if (!entity || !userId) return null

  return (
    <EmploymentSection
      entity={entity}
      userId={userId}
      getEmploymentData={() => getSectionData('employment')}
      onDataFetched={handleDataFetched}
      updateEmploymentData={handleUpdateEmploymentData}
      readOnly={readOnly}
    />
  )
}
